import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { usePermissions } from '../hooks/usePermissions';

const ProtectedRoute = ({ children, isSuperuserRoute, resource, action }) => {
    const { user, isAuthenticated } = useAuth();
    const { hasPermission, loading: permissionsLoading } = usePermissions(resource);

    if (!isAuthenticated) {
        return <Navigate to="/login" replace />;
    }

    // While permissions are loading, show a loading indicator
    if (resource && permissionsLoading) {
        return <div className="text-center">Загрузка прав доступа...</div>; // Or a proper spinner component
    }

    // New permission system check
    if (resource && action && !hasPermission(action)) {
        return <Navigate to="/" replace />;
    }

    // Superuser route check (can be kept for non-resource-based routes)
    if (isSuperuserRoute) {
        if (!user || !user.is_superuser) {
            return <Navigate to="/" replace />;
        }
    }

    return children;
};

export default ProtectedRoute;
